import { GlobalHttpClient } from '../global.http.client';

export abstract class BaseService {
    constructor(protected http: GlobalHttpClient) {
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/base.service.ts